import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import PropertyDetail from "@/pages/PropertyDetail";
import BlogDetail from "@/pages/BlogDetail";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AboutPage from "@/pages/AboutPage";
import CeoMessage from "@/pages/CeoMessage";
import ListingsPage from "@/pages/ListingsPage";
import { AdminAuthProvider } from "@/contexts/AdminAuth";
import { SiteContentProvider } from "@/contexts/SiteContent";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <SiteContentProvider>
          <AdminAuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/vision" element={<CeoMessage />} />
              <Route path="/listings" element={<ListingsPage />} />
              <Route path="/listings/:slug" element={<PropertyDetail />} />
              <Route path="/journal/:slug" element={<BlogDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AdminAuthProvider>
        </SiteContentProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#181613",
            color: "#f5f0e8",
            border: "1px solid rgba(197,160,89,0.15)",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
